import { ToggleGroup, ToggleGroupItem } from '@nesso/ui/primitives/toggle-group';

import type { NotesSettingsValue } from '@/entities/practice-member-settings';
import { SettingsRow } from '@/shared/ui/settings/settings-row';

import { useNotesSetting } from '../model/use-notes-setting';

type ToggleField = 'noteFormat' | 'noteLength' | 'identifier';

type Option<T extends string> = {
    value: T;
    label: string;
};

type Props<F extends ToggleField> = {
    field: F;
    label: string;
    options: readonly Option<NotesSettingsValue[F]>[];
};

export function NoteToggleInput<F extends ToggleField>({ field, label, options }: Props<F>) {
    const { value, save } = useNotesSetting(field);

    return (
        <SettingsRow
            label={label}
            trailing={
                <ToggleGroup
                    type="single"
                    variant="outline"
                    size="sm"
                    value={value}
                    onValueChange={(val) => {
                        if (val) {
                            save(val as NotesSettingsValue[F]);
                        }
                    }}
                    className="flex-1 gap-2"
                >
                    {options.map((option) => (
                        <ToggleGroupItem key={option.value} value={option.value} className="flex-1">
                            {option.label}
                        </ToggleGroupItem>
                    ))}
                </ToggleGroup>
            }
        />
    );
}
